<section id="container">
  <ng-container *ngIf="heading">
    <h2 class="text-center fw-bold fs-1">
      {{ "Plan&Features.Plan" | translate
      }}<span class="text-primary">{{
        "Plan&Features.Features" | translate
      }}</span>
    </h2>
    <p class="text-center fw-medium">
      {{ "Plan&Features.Advanced-Features" | translate }}
    </p>
  </ng-container>

  <div id="premium-container">
    <div id="premium-container-header">
      <div id="premium-container-price-section">
        <s class="fw-medium" style="opacity: 50%">{{
          "Plan&Features.$15" | translate
        }}</s>
        <div>
          <span class="fw-medium">{{
            "Plan&Features.Monthly" | translate
          }}</span>
          <h3 class="mb-0 fw-bold fs-1" style="color: #0b0762">
            {{ "Plan&Features.$7.50" | translate }}
          </h3>
        </div>
      </div>
      <div>
        <img [src]="getLocalizedImagePath('discount')" alt="" />
      </div>
      <div id="subscribe-button-container">
        <a
          [href]="hidePremium ? '/accountsettings?ref=premium' : '/plans'"
          style="width: 100%"
          (click)="
            hidePremium
              ? redirectToAccount($event)
              : selectPlan($event, plans[0].id)
          "
          *ngIf="loaded"
          class="subscribe-button"
        >
          <svg
            width="28"
            height="22"
            viewBox="0 0 28 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.0544 7.58713L21.4678 8.41403C22.0564 9.5926 21.4892 11.048 19.9654 11.4717C19.9462 11.4781 17.8356 12.0446 17.1947 10.1247L16.5769 8.26897L18.3349 6.5102L13.9968 0.00390625L9.65871 6.5102L11.4167 8.26897L10.7989 10.1247C10.0919 12.243 7.18227 11.7443 6.49612 10.2505C6.2253 9.66239 6.23651 8.99336 6.52576 8.41403L6.93842 7.5879L0 5.11119L3.3303 17.8931L4.9713 19.534H13.9968H23.0223L24.6633 17.8931L28 5.11201L21.0544 7.58713Z"
              fill="#FED843"
            />
            <path
              d="M24.6626 17.8931L27.9993 5.11201L21.0537 7.58713L21.4671 8.41403C22.0556 9.5926 21.4885 11.048 19.9647 11.4717C19.9455 11.4781 17.8349 12.0446 17.194 10.1247L16.5762 8.26897L18.3342 6.5102L13.9961 0.00390625V19.534H23.0216L24.6626 17.8931Z"
              fill="#FABE2C"
            />
            <path
              d="M13.9966 17.8926H3.33008V21.9951H13.9966H24.6631V17.8926H13.9966Z"
              fill="#FABE2C"
            />
            <path
              d="M13.9961 17.8926H24.6626V21.9951H13.9961V17.8926Z"
              fill="#FF9100"
            />
            <path
              d="M9.89062 17.8926L13.9925 13.7907L18.0944 17.8926L13.9925 21.9945L9.89062 17.8926Z"
              fill="#FABE2C"
            />
            <path
              d="M13.9961 13.791V21.996L18.0986 17.8935L13.9961 13.791Z"
              fill="#FF9100"
            />
          </svg>

          <span>{{ "Plan&Features.Subscribe-Now" | translate }}</span>
        </a>
      </div>
    </div>

    <ul class="list-unstyled mb-0">
      <li>
        <ng-container *ngTemplateOutlet="icon"></ng-container>
        <span> {{ "Plan&Features.Unlimited-Grammar-Check" | translate }}</span>
      </li>
      <li>
        <ng-container *ngTemplateOutlet="icon"></ng-container>
        <span>{{
          "Plan&Features.Unlimited-Plagiarism-Check" | translate
        }}</span>
      </li>
      <li>
        <ng-container *ngTemplateOutlet="icon"></ng-container>
        <span>
          {{ "Plan&Features.Unlimited-Text-Summarizer" | translate }}</span
        >
      </li>
      <li>
        <ng-container *ngTemplateOutlet="icon"></ng-container>
        <span>{{ "Plan&Features.Unlimited-Paraphrasing" | translate }}</span>
      </li>
      <li>
        <ng-container *ngTemplateOutlet="icon"></ng-container>
        <span> {{ "Plan&Features.AI-Assistant" | translate }}</span>
      </li>
    </ul>
  </div>
</section>

<ng-template #icon>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.50401 0.317383C14.5773 0.317383 18.6916 4.4317 18.6916 9.50498C18.6916 14.5783 14.5773 18.6926 9.50401 18.6926C4.43073 18.6926 0.316406 14.5783 0.316406 9.50498C0.316406 4.4317 4.43073 0.317383 9.50401 0.317383ZM7.59609 12.4892L5.34674 10.238C4.96353 9.85453 4.96345 9.22925 5.34674 8.84589C5.73011 8.4626 6.35817 8.465 6.73875 8.84589L8.32453 10.4329L12.2694 6.48803C12.6528 6.10466 13.2781 6.10466 13.6614 6.48803C14.0448 6.87132 14.0442 7.49721 13.6614 7.88004L9.01941 12.5221C8.63659 12.9049 8.01069 12.9054 7.6274 12.5221C7.61663 12.5113 7.60624 12.5003 7.59609 12.4892Z"
      fill="#08BA9C"
    />
  </svg>
</ng-template>
